/**
 * Nomes dos tipos de regra, em um lugar só.
 *
 * Existiam TRÊS listas escritas à mão — a de criação de regras, a de
 * subscriptions e o mapa do dispatcher no backend — e elas divergiram. A de
 * subscriptions ficou com 6 dos 12 kinds: quem quisesse mandar só "queda de
 * energia no site" para um canal simplesmente não achava a opção. Falha
 * silenciosa, porque a tela não tem como saber o que está faltando nela.
 *
 * `Record<RuleKind, string>` é o que impede isso de repetir: acrescentar um
 * kind ao tipo sem dar nome aqui quebra o build. As duas telas derivam
 * daqui, então nenhuma pode ficar para trás.
 */

import type { RuleKind } from "@/types";

export const RULE_KIND_LABELS: Record<RuleKind, string> = {
  temp_out_of_range:  "Temperatura fora do range",
  device_offline:     "Sensor sem comunicação",
  low_battery:        "Bateria baixa",
  weak_signal:        "Sinal fraco",
  door_open_too_long: "Porta aberta há muito tempo",
  power_off:          "Compressor desligado",
  plug_off:           "Tomada desligada",
  power_overload:     "Sobrecarga no compressor",
  current_spike:      "Pico de corrente",
  medicao_incoerente: "Medição congelada",
  site_power_outage:  "Queda de energia no site",
  tenant_silent:      "Cliente sem telemetria",
  conexao_reserva:    "Gateway na internet de reserva (4G)",
};

/**
 * Avaliados FORA do registry por equipment — o engine pós-processa por site
 * e por tenant, com tabela de estado própria. Não são criáveis como regra
 * comum, mas GERAM notificação, então a tela de subscriptions precisa
 * oferecê-los. Foi a distinção que a lista antiga perdeu.
 */
const CROSS_DEVICE = new Set<RuleKind>(["site_power_outage", "tenant_silent", "conexao_reserva"]);

const TODOS = Object.keys(RULE_KIND_LABELS) as RuleKind[];

/** O que dá pra criar na tela de regras. */
export const KINDS_CRIAVEIS: RuleKind[] = TODOS.filter((k) => !CROSS_DEVICE.has(k));

/** O que pode gerar notificação — é isto que subscriptions filtra. */
export const KINDS_NOTIFICAVEIS: RuleKind[] = TODOS;

export function opcoesDeKind(kinds: RuleKind[]): { value: RuleKind; label: string }[] {
  return kinds.map((k) => ({ value: k, label: RULE_KIND_LABELS[k] }));
}
